import { createSeenCountRequest } from "../../../modules/students-modules/videos/Actions";

export const countSeens = async (dispatch, data) => {
  const formData = {
    video_id: data?.id,
    seen: true,
    views_count: 1,
    exception: 0,
    user_video_suspended: 0,
    total_covered: 0,
    total_played: 0,
  };
  if (!data?.views_count?.views_count)
    await dispatch(createSeenCountRequest(formData));
};
